import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../base/base-api.service';
import { OrderByConfig, ApiFilter, FieldsSelection, DefaultFilter } from 'src/app/models/apiParams.model';
import { apiResponse } from 'src/app/models/apiResponse.model';

/**
 * Accounting Service - Handles accounting jobs
 */
@Injectable({ providedIn: 'root' })
export class AccountingService extends BaseApiService {

    constructor(http: HttpClient) {
        super(http);
    }

    /*-------------------------
    == ACCOUNTING CALLS ==
    -------------------------*/
    getAccountingJobs(limit: number, page: number, orderBy?: string | OrderByConfig[], filter?: string | ApiFilter, fields?: FieldsSelection, defaultFilter?: DefaultFilter): Observable<apiResponse> {
        return this.getAll<apiResponse>('/accounting/v1/job', { limit, page, orderBy, filter, fields, defaultFilter });
    }

    runAccountingJobs(): Observable<apiResponse> {
        return this.putPath<apiResponse>('/accounting/v1/job/run/', null);
    }

    deleteAccountingJob(id: number): Observable<apiResponse> {
        return this.delete<apiResponse>('/accounting/v1/job/', id);
    }

    addAccountingJob(data: any): Observable<apiResponse> {
        return this.post<apiResponse>('/accounting/v1/job', data, 'json');
    }

    /*-------------------------
    == ITEM CODES CALLS ==
    -------------------------*/
    getItemCodes(limit: number, page: number, orderBy?: string | OrderByConfig[], filter?: string | ApiFilter, fields?: FieldsSelection, defaultFilter?: DefaultFilter): Observable<apiResponse> {
        return this.getAll<apiResponse>('/accounting/v1/item-code', { limit, page, orderBy, filter, fields, defaultFilter });
    }

    getItemCode(id: number, fields?: FieldsSelection): Observable<apiResponse> {
        return this.getById<apiResponse>('/accounting/v1/item-code/', id, { fields });
    }

    updateItemCode(id: number, data: { value: string }): Observable<apiResponse> {
        return this.put<apiResponse>('/accounting/v1/item-code/', id, data, 'json');
    }
}
